import styles from './styles/Divider.module.scss';

const Divider = ({ text }: { text?: string }) => {
  return (
    <>
      {text ? (
        <div className={styles.dividerWrapper} data-cxy-name="divider">
          <hr className={styles.divider} />
          <span className={styles.text}>{text}</span>
          <hr className={styles.divider} />
        </div>
      ) : (
        <hr className={styles.divider} data-cxy-name="divider" />
      )}
    </>
  );
};

export { Divider };
